import React, { useState } from 'react';
import CONFIG from '../../../config';
import './styles/index.css';
import { FaLinkedinIn, FaFacebookF, FaInstagram, FaQuora, FaGithub } from 'react-icons/fa';

export default function TestimonialsGridItem({ data, variant }) {
  const { id, img, name, country, flag, socialIcon, video, thumbnail, description, videoDescription, profession, certificateSrc } = data;
  const cloudFront = CONFIG.cloudFront;
  const [videoRendering, setVideoRendering] = useState(0);

  const playTestimonial = () => {
    let TestimonialThumbail = document.getElementById(`testimonial-thumbnail-${id}`);
    let TestimonialPlayIcon = document.getElementById(`tstmnl-play-icon-${id}`);
    TestimonialThumbail.style.display = 'none';
    setVideoRendering(id);

    setTimeout(() => {
      let TestimonialVideo = document.getElementById(`testimonial-video-${id}`);
      if (TestimonialVideo.paused) {
        TestimonialPlayIcon.style.display = 'none';
        TestimonialVideo.play();
      } else {
        TestimonialPlayIcon.style.display = 'unset';
        TestimonialVideo.pause();
      }
    }, 100);
  };

  return (
    <div className="testimonial-card-container">
      {video ? (
        <div className="testimonial-card video-testimonial-card">
          <div className="testimonial-video-thumbnail-wrapper">
            <div className="testimonial-thumbnail-container" id={`testimonial-thumbnail-${id}`} onClick={() => playTestimonial()}>
              <div className="d-flex flex-column video-reviewer-details">
                <h4 className="text-left pb-1">{name}</h4>
                <div className="d-flex align-items-center">
                  <img className="testimonial-flag-img" src={flag} alt={`${country} flag`} />
                  <p className="fs-14 ml-1">{country}</p>
                </div>
              </div>
              <img className="testimonial-thumbnail" src={cloudFront + thumbnail} alt={`Reviewer ${id} thumbnail`} />
            </div>

            {videoRendering === id && (
              <div className="testimonial-video-container">
                <video
                  className="testimonial-video"
                  id={`testimonial-video-${id}`}
                  src={cloudFront + video}
                  poster={cloudFront + thumbnail}
                  onClick={() => playTestimonial()}
                ></video>
              </div>
            )}

            {/*{variant === 'partner-plus' ? (
              <img className="testimonial-play-icon no-pointers" id={`tstmnl-play-icon-${id}`} src={cloudFront + '/Assets/PartnerPlus/partnerTestimonialPlayicon.svg'} alt="" />
            ) : variant === 'regionals' ? (
              <img className="testimonial-play-icon no-pointers" id={`tstmnl-play-icon-${id}`} src={cloudFront + '/Assets/Regionals/regionalsTestimonialPlayicon.svg'} alt="" />
            ) : variant === 'code-juniors' ? (
              <img className="testimonial-play-icon no-pointers" id={`tstmnl-play-icon-${id}`} src={cloudFront + '/Assets/Juniors/juniorsTestimonialPlayicon.svg'} alt="" />
            ) : (
            )}*/}
            <img className="testimonial-play-icon no-pointers" id={`tstmnl-play-icon-${id}`} src={cloudFront + '/Assets/IconsPack/testimonialPlayicon.svg'} alt="" />
          </div>

          <div className="testimonial-video-wrapper">
            <p className="fs-14 darkGreyTxt">"{videoDescription}"</p>
          </div>
        </div>
      ) : certificateSrc ? (
        <div className="testimonial-card certificate-testimonial-card">
          <div className="d-flex align-items-center pb-2">
            <img className="testimonial-img" src={cloudFront + img} alt={`${name} profile pic`} />
            <div className="pl-2">
              <h4 className="darkTxt pb-1">{name}</h4>
              <p className="certificate-testimonial-profession text-muted fs-12 no-line-height">{profession}</p>
            </div>
          </div>
          <p className="certificate-testimonial-text fs-14 darkGreyTxt" dangerouslySetInnerHTML={{ __html: description }}></p>
          <img className="w-100 mt-3" src={cloudFront + certificateSrc} alt="Log2Base2 certificate" style={{ border: '1px solid var(--siteSecondaryBgColor)' }} />
        </div>
      ) : (
        <div className="testimonial-card text-testimonial-card">
          {/* reviewer details */}
          <div className="d-flex align-items-center">
            <img className="testimonial-img align-self-start overflow-hidden" src={cloudFront + img} alt={`img ${id}`} />
            <div className="testimonial-reviewer-details d-flex flex-column">
              <h4 className="darkTxt text-left pb-1">{name}</h4>

              <div className="d-flex align-items-center">
                <img className="testimonial-flag-img" src={flag} alt={`${country} flag`} />
                <p className="fs-14 text-muted ml-1">{country}</p>
              </div>
            </div>
            {/* social icons */}
            <span className="testimonial-social-icon">
              {socialIcon === 'linkedin' ? (
                <FaLinkedinIn className="icon-linkedin" />
              ) : socialIcon === 'facebook' ? (
                <FaFacebookF className="icon-facebook" />
              ) : socialIcon === 'instagram' ? (
                <FaInstagram className="icon-instagram" />
              ) : socialIcon === 'quora' ? (
                <FaQuora className="icon-quora" />
              ) : (
                <FaGithub className="icon-github" />
              )}
            </span>
          </div>
          <hr className="testimonial-hr-line" />
          <p className="fs-14 darkGreyTxt text-left">{description}</p>
        </div>
      )}
    </div>
  );
}
